import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=ef975b94&scoped=true&"
import script from "./AppFooter.vue?vue&type=script&lang=js&"
export * from "./AppFooter.vue?vue&type=script&lang=js&"
import style0 from "./AppFooter.vue?vue&type=style&index=0&id=ef975b94&prod&lang=css&"
import style1 from "./AppFooter.vue?vue&type=style&index=1&id=ef975b94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef975b94",
  null
  
)

export default component.exports